/** Byte count → short French label ("12 Ko", "1.4 Mo"); empty for 0/null. */
export function humanSize(n: number | null | undefined): string {
  if (!n) return '';
  if (n < 1024) return `${n} o`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} Ko`;
  return `${(n / (1024 * 1024)).toFixed(1)} Mo`;
}
